/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Plan_FreeInputs */

const en_settings_plan_free = /** @type {(inputs: Settings_Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const de_settings_plan_free = /** @type {(inputs: Settings_Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos`)
};

const fr_settings_plan_free = /** @type {(inputs: Settings_Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuit`)
};

const es_settings_plan_free = /** @type {(inputs: Settings_Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const it_settings_plan_free = /** @type {(inputs: Settings_Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const nl_settings_plan_free = /** @type {(inputs: Settings_Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const pl_settings_plan_free = /** @type {(inputs: Settings_Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darmowy`)
};

const fi_settings_plan_free = /** @type {(inputs: Settings_Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmainen`)
};

const da_settings_plan_free = /** @type {(inputs: Settings_Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const sv_settings_plan_free = /** @type {(inputs: Settings_Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

/**
* | output |
* | --- |
* | "Free" |
*
* @param {Settings_Plan_FreeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_plan_free = /** @type {((inputs?: Settings_Plan_FreeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Plan_FreeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_plan_free(inputs)
	if (locale === "fr") return fr_settings_plan_free(inputs)
	if (locale === "es") return es_settings_plan_free(inputs)
	if (locale === "it") return it_settings_plan_free(inputs)
	if (locale === "nl") return nl_settings_plan_free(inputs)
	if (locale === "pl") return pl_settings_plan_free(inputs)
	if (locale === "fi") return fi_settings_plan_free(inputs)
	if (locale === "da") return da_settings_plan_free(inputs)
	if (locale === "sv") return sv_settings_plan_free(inputs)
	return en_settings_plan_free(inputs)
});